import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

const ViewDetailsIcon = ({ row, tooltip, onClick }) => {
  return (
    <IconButton color="primary" size="small" onClick={() => onClick({ row })}>
      <Tooltip id="button-report" title={tooltip}>
        <InfoOutlinedIcon fontSize="small" />
      </Tooltip>
    </IconButton>
  );
};

export default ViewDetailsIcon;
